import { useState, useEffect } from 'react';
import axios from 'axios';

const useFetchResults = (promoId, sorteioId) => {
    const [results, setResults] = useState([]);
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/admin/resultados?promo_id=${promoId}&sorteio_id=${sorteioId}`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('adminAccessToken')}`
                }
            })
            .then((response) => {
                setResults(response.data.data);
            })
            .catch((err) => {
                console.error(err);
            })
    }, [sorteioId, promoId]);

    return results;
}

export default useFetchResults;